import standardAPI from '@/api/standard_items';

const state = {
  phone_country_codes: [],
  phone_country_codes_status: '',
  phone_country_codes_MetaData: {},
  phone_country_codes_page: 1,
  phone_country_codes_perPage: 10,
};

const responseUrl = '/static/phone-country-codes';

const getters = {};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_phone_country_codes ({ commit }, getOptions) {
    commit('PHONE_COUNTRY_CODES_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('PHONE_COUNTRY_CODES_SUCCESS', response);
            commit('PHONE_COUNTRY_CODES_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('PHONE_COUNTRY_CODES_READY');
            reject(response);
          } else {
            commit('PHONE_COUNTRY_CODES_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_phone_country_code ({ commit, dispatch }, itemData) {
    commit('PHONE_COUNTRY_CODES_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          commit('PHONE_COUNTRY_CODES_READY');
          resolve(response);
        } else {
          commit('PHONE_COUNTRY_CODES_READY');
          reject(response);
        }
      });
    });
  },
  edit_phone_country_code ({ commit, dispatch }, itemData) {
    commit('PHONE_COUNTRY_CODES_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          commit('PHONE_COUNTRY_CODES_READY');
          resolve(response);
        } else {
          commit('PHONE_COUNTRY_CODES_READY');
          reject(response);
        }
      });
    });
  },
  remove_phone_country_code ({ commit, dispatch }, itemData) {
    commit('PHONE_COUNTRY_CODES_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          commit('PHONE_COUNTRY_CODES_READY');
          resolve();
        } else {
          commit('PHONE_COUNTRY_CODES_READY');
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.phone_country_codes_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.phone_country_codes_perPage = max;
  },
  PHONE_COUNTRY_CODES_READY: (state) => {
    state.phone_country_codes_status = 'ready';
  },
  PHONE_COUNTRY_CODES_REQUEST: (state) => {
    state.phone_country_codes_status = 'loading';
  },
  PHONE_COUNTRY_CODES_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.phone_country_codes_MetaData.meta = response.meta;
      state.phone_country_codes_MetaData.links = response.links;
    }
    state.phone_country_codes = response.data;
    state.phone_country_codes_status = 'success';
  },
  PHONE_COUNTRY_CODES_ERROR: (state) => {
    state.phone_country_codes_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
